import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/features/marketing/content/content-page";
import { body } from "@/features/marketing/content/pages/plan-a-wedding-together";
import { SEO } from "@/features/marketing/seo";

export const Route = createFileRoute("/_marketing/plan-a-wedding-together")({
  head: SEO["/plan-a-wedding-together"],
  component: () => <ContentPage path="/plan-a-wedding-together" body={body} />,
});
